import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { VoucherMaster } from "./VoucherMaster";

const VoucherManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <VoucherMaster />} />
  </Switch>
);

export const VoucherManagement = withRouter(VoucherManagementRoutes);
